import { HERO_EXPERT_TRUST_PORTRAITS } from '../data/endorsements';

export function scrollToExpertEndorsements() {
  const el = document.getElementById('expert-endorsements');
  if (!el) return;

  const top = el.getBoundingClientRect().top + window.scrollY - 80;
  window.scrollTo({ top, behavior: 'smooth' });
}

export default function HeroExpertTrust() {
  return (
    <a
      href="#expert-endorsements"
      onClick={(event) => {
        event.preventDefault();
        scrollToExpertEndorsements();
      }}
      className="mx-auto mb-8 mt-4 inline-flex items-center gap-2.5 rounded-full border border-white/[0.08] bg-white/[0.03] pl-3 pr-4 py-2 text-[13px] leading-5 font-medium text-slate-300 transition-colors hover:bg-white/[0.05] md:max-w-full md:text-sm"
    >
      <span className="flex shrink-0 -space-x-2" aria-hidden="true">
        {HERO_EXPERT_TRUST_PORTRAITS.map((portrait) => (
          <span
            key={portrait.name}
            className="inline-flex h-7 w-7 overflow-hidden rounded-full border border-deep-purple bg-white/10"
          >
            {portrait.image ? (
              <img
                src={portrait.image}
                alt=""
                className="h-full w-full object-cover"
                loading="lazy"
              />
            ) : (
              <span className="m-auto text-[10px] font-semibold text-white/70">
                {portrait.name.slice(0, 1)}
              </span>
            )}
          </span>
        ))}
      </span>

      <span className="w-[11.75rem] min-w-0 text-center md:w-auto md:text-left">
        <span className="block md:inline">Created with sexologists &amp;</span>
        <span className="hidden md:inline"> </span>
        <span className="block md:inline">relationship therapists</span>
      </span>
    </a>
  );
}
